import React from 'react';
import { Card } from 'antd';
import { map } from 'lodash';
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import { propsToDisplay } from './PolicySetPropsToDisplay';
import IconSvg from '../../../common/IconSvg';
import { themeColors } from '../../../../constants/themes';

const Container = styled.div`
  display: flex;
  flex-direction: column;
  width: 95%;
  margin-top: 0.5em;
`;

const ControlsRow = styled.div`
  display: flex;
  justify-content: space-between;
  margin-bottom: 5px;
  & span {
    margin-right: 0.5em;
  }
`;

const CustomCard = styled(Card)`
  background: ${themeColors.backgroundDarkGray};
  ${''} height: 12em;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  box-shadow: 0px 1px 6px 0 rgba(71, 69, 136, 0.11);
  padding-bottom: 3em;
  & .ant-card-head-title {
    padding: 13px 0 5px;
  }
  & .TMline {
    text-overflow: ellipsis;
    white-space: nowrap;
    overflow: hidden;
    line-height: 1.5;
  }
  &:hover {
    border: 1px solid ${themeColors.eggplantBlue};
  }
`;

@injectIntl
export class PolicyCard extends React.Component {
  constructor() {
    super();
    this.state = {
      isHovered: null,
    };
  }

  render() {
    const {
      policy,
      intl,
      handleClick,
      toggleDefault,
      deletePolicy,
      clonePolicy,
      isDefault,
      isNonApi,
    } = this.props;
    const { policyId: code, ...features } = policy;
    return (
      <Container
        onMouseEnter={() => this.setState({ isHovered: true })}
        onMouseLeave={() => this.setState({ isHovered: false })}
      >
        <ControlsRow>
          <div
            style={{ cursor: isDefault ? '' : 'pointer' }}
            onClick={isDefault ? null : toggleDefault}
          >
            {intl.formatMessage({ id: isDefault ? 'listing.default' : 'listing.makeDefault' })}
          </div>
          <div style={{ opacity: this.state.isHovered ? 1 : 0, transition: '0.3s' }}>
            {!isDefault && <IconSvg onClick={deletePolicy} key="delete" type="delete" size={16} />}
            <IconSvg onClick={clonePolicy} key="clone" type="copy" size={16} />
          </div>
        </ControlsRow>
        <CustomCard
          style={isNonApi ? { cursor: 'default' } : {}}
          bordered={false}
          headStyle={{ margin: '0 24px', padding: '0' }}
          bodyStyle={{ padding: '1em 24px' }}
          title={<div className="title3">{policy.name}</div>}
          onClick={handleClick}
        >
          {map(propsToDisplay, (value, key) => {
            const val = features[key];
            if (val) {
              return (
                <div key={key} className="TMline">
                  {intl.formatMessage({ id: `listing.${value}` })} : {val}
                </div>
              );
            }
            return null;
          })}
        </CustomCard>
      </Container>
    );
  }
}

PolicyCard.propTypes = {
  intl: PropTypes.object,
  policy: PropTypes.object,
  handleClick: PropTypes.func,
  toggleDefault: PropTypes.func,
  deletePolicy: PropTypes.func,
  clonePolicy: PropTypes.func,
  isDefault: PropTypes.bool,
  isNonApi: PropTypes.bool,
};
